module.exports = __webpack_public_path__ + "img/btn_pg_wechatpay.7a3a35bd.png";